/* ================================
  grid product image slider
================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ----------------
    util：安全な closest
  ---------------- */

  function getClosestContent(target) {
    if (!target) return null;

    // TextNode 対策
    if (target.nodeType !== 1) {
      target = target.parentElement;
    }

    return target ? target.closest('.grid-product__content') : null;
  }

  /* ----------------
    共通：インジケーター
  ---------------- */

  function initIndicator(mask, total) {
    if (mask.querySelector('.grid-product__indicator')) return;

    const indicator = document.createElement('div');
    indicator.className = 'grid-product__indicator';

    let dots = '';
    for (let i = 0; i < total; i++) {
      dots += `<span class="dot${i === 0 ? ' is-active' : ''}"></span>`;
    }

    indicator.innerHTML = `
      <div class="indicator-numbers">
        <span class="current">1</span> / <span class="total">${total}</span>
      </div>
      <div class="indicator-dots">
        ${dots}
      </div>
    `;

    mask.appendChild(indicator);
  }

  function updateIndicator(mask, index, total) {
    initIndicator(mask, total);

    const current = mask.querySelector('.indicator-numbers .current');
    const totalEl = mask.querySelector('.indicator-numbers .total');

    if (current && totalEl) {
      current.textContent = index + 1;
      totalEl.textContent = total;
    }

    const dots = mask.querySelectorAll('.indicator-dots .dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  /* ----------------
    初期化（全商品）
  ---------------- */

  document.querySelectorAll('.grid-product__image-mask').forEach(mask => {
    if (!mask.dataset.media) return;

    const images = JSON.parse(mask.dataset.media);
    const index = Number(mask.dataset.index || 0);
    updateIndicator(mask, index, images.length);
  });

  /* ----------------
    hover：2枚目表示 + インジケーター同期
  ---------------- */

  document.addEventListener('mouseenter', (e) => {
    const content = getClosestContent(e.target);
    if (!content) return;

    const mask = content.querySelector('.grid-product__image-mask');
    if (!mask || !mask.dataset.media) return;

    // JS操作済みなら hover は無効
    if (mask.classList.contains('is-slider-active')) return;

    const images = JSON.parse(mask.dataset.media);
    if (images.length < 2) return;

    const img = mask.querySelector('img');
    if (!img) return;

    const index = 1;

    img.src = images[index].src;
    img.srcset = images[index].srcset;
    mask.dataset.index = index;

    updateIndicator(mask, index, images.length);
  }, true);

  /* ----------------
    hover解除：1枚目に戻す
  ---------------- */

  document.addEventListener('mouseleave', (e) => {
    const content = getClosestContent(e.target);
    if (!content) return;

    const mask = content.querySelector('.grid-product__image-mask');
    if (!mask || !mask.dataset.media) return;

    // JSスライダー操作後は戻さない
    if (mask.classList.contains('is-slider-active')) return;

    const images = JSON.parse(mask.dataset.media);
    if (!images.length) return;

    const img = mask.querySelector('img');
    if (!img) return;

    const index = 0;

    img.src = images[index].src;
    img.srcset = images[index].srcset;
    mask.dataset.index = index;

    updateIndicator(mask, index, images.length);
  }, true);

  /* ----------------
    PC：prev / next ボタン
  ---------------- */

  document.addEventListener('click', (e) => {
    const prev = e.target.closest('.grid-product__image-prev');
    const next = e.target.closest('.grid-product__image-next');
    if (!prev && !next) return;

    const content = getClosestContent(e.target);
    if (!content) return;

    const mask = content.querySelector('.grid-product__image-mask');
    if (!mask || !mask.dataset.media) return;

    const images = JSON.parse(mask.dataset.media);
    const img = mask.querySelector('img');

    let index = Number(mask.dataset.index || 0);
    if (next) index++;
    if (prev) index--;

    if (index < 0) index = images.length - 1;
    if (index >= images.length) index = 0;

    mask.classList.add('is-slider-active');

    img.src = images[index].src;
    img.srcset = images[index].srcset;
    mask.dataset.index = index;

    updateIndicator(mask, index, images.length);
  });

  /* ----------------
    SP：スワイプ操作
  ---------------- */

  let startX = 0;
  let currentX = 0;
  let activeMask = null;
  const SWIPE_THRESHOLD = 40;

  document.addEventListener('touchstart', (e) => {
    const content = getClosestContent(e.target);
    if (!content) return;

    const mask = content.querySelector('.grid-product__image-mask');
    if (!mask || !mask.dataset.media) return;

    activeMask = mask;
    startX = e.touches[0].clientX;
  }, { passive: true });

  document.addEventListener('touchmove', (e) => {
    if (!activeMask) return;
    currentX = e.touches[0].clientX;
  }, { passive: true });

  document.addEventListener('touchend', () => {
    if (!activeMask) return;

    const diffX = currentX - startX;
    if (Math.abs(diffX) < SWIPE_THRESHOLD) {
      activeMask = null;
      return;
    }

    const images = JSON.parse(activeMask.dataset.media);
    const img = activeMask.querySelector('img');
    let index = Number(activeMask.dataset.index || 0);

    if (diffX < 0) index++;
    else index--;

    if (index < 0) index = images.length - 1;
    if (index >= images.length) index = 0;

    activeMask.classList.add('is-slider-active');

    img.src = images[index].src;
    img.srcset = images[index].srcset;
    activeMask.dataset.index = index;

    updateIndicator(activeMask, index, images.length);

    activeMask = null;
  });

});